import { convertToDate } from "utils";
import fields from "../Field.constants";
import { updateEndDate, updateReleaseDate } from "./isUpdating";

function contractDateUpdatesAreInvalid(appointments, updates) {
    if (!updateReleaseDate(updates) && !updateEndDate(updates)) {
        return false;
    }

    const releaseValue = convertToDate(updates.find(u => u.field === fields.ContractReleaseDate)?.value);
    const endValue = convertToDate(updates.find(u => u.field === fields.ContractEndDate)?.value);

    if (releaseValue && endValue) {
        return releaseValue > endValue;
    }

    return appointments.findIndex(appointment => {
        const releaseDate = convertToDate(appointment.contract.releaseDate);
        const endDate = convertToDate(appointment.contract.endDate);
        return (releaseValue && releaseValue > endDate) ||
            (endValue && releaseDate > endValue);
    }) !== -1;
}

export default contractDateUpdatesAreInvalid;